// extracted by mini-css-extract-plugin
export default {"emailSuccess":"MessageResultPopup_emailSuccess__u7QFI"};